import { render } from "./CustomerAgreementOrderForm.vue?vue&type=template&id=65ab7900&scoped=true"
import script from "./CustomerAgreementOrderForm.vue?vue&type=script&lang=js"
export * from "./CustomerAgreementOrderForm.vue?vue&type=script&lang=js"

import "./CustomerAgreementOrderForm.vue?vue&type=style&index=0&id=65ab7900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ab7900"]])

export default __exports__